/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { RedeemerErrorArchivePagedResponse } from '../models';
import { RedeemerErrorPagedResponse } from '../models';
import { ResolutionPost } from '../models';
/**
 * RedeemerErrorApi - axios parameter creator
 * @export
 */
export const RedeemerErrorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [searchTerm] 
         * @param {boolean} [showResolved] 
         * @param {boolean} [showUnresoved] 
         * @param {string} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedeemerErrorArchivedGet: async (server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, showResolved?: boolean, showUnresoved?: boolean, languageCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RedeemerError/archived`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDesc !== undefined) {
                localVarQueryParameter['sortDesc'] = sortDesc;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (showResolved !== undefined) {
                localVarQueryParameter['showResolved'] = showResolved;
            }

            if (showUnresoved !== undefined) {
                localVarQueryParameter['showUnresoved'] = showUnresoved;
            }

            if (languageCode !== undefined) {
                localVarQueryParameter['languageCode'] = languageCode;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedeemerErrorDeleteDelete: async (server?: string, id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RedeemerError/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [searchTerm] 
         * @param {boolean} [showResolved] 
         * @param {boolean} [showUnresoved] 
         * @param {string} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedeemerErrorGetGet: async (server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, showResolved?: boolean, showUnresoved?: boolean, languageCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RedeemerError/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDesc !== undefined) {
                localVarQueryParameter['sortDesc'] = sortDesc;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (showResolved !== undefined) {
                localVarQueryParameter['showResolved'] = showResolved;
            }

            if (showUnresoved !== undefined) {
                localVarQueryParameter['showUnresoved'] = showUnresoved;
            }

            if (languageCode !== undefined) {
                localVarQueryParameter['languageCode'] = languageCode;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResolutionPost} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedeemerErrorResolvePost: async (body?: ResolutionPost, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RedeemerError/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RedeemerErrorApi - functional programming interface
 * @export
 */
export const RedeemerErrorApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [searchTerm] 
         * @param {boolean} [showResolved] 
         * @param {boolean} [showUnresoved] 
         * @param {string} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerErrorArchivedGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, showResolved?: boolean, showUnresoved?: boolean, languageCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<RedeemerErrorArchivePagedResponse>>> {
            const localVarAxiosArgs = await RedeemerErrorApiAxiosParamCreator(configuration).apiRedeemerErrorArchivedGet(server, page, itemsPerPage, sortBy, sortDesc, searchTerm, showResolved, showUnresoved, languageCode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerErrorDeleteDelete(server?: string, id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await RedeemerErrorApiAxiosParamCreator(configuration).apiRedeemerErrorDeleteDelete(server, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [searchTerm] 
         * @param {boolean} [showResolved] 
         * @param {boolean} [showUnresoved] 
         * @param {string} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerErrorGetGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, showResolved?: boolean, showUnresoved?: boolean, languageCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<RedeemerErrorPagedResponse>>> {
            const localVarAxiosArgs = await RedeemerErrorApiAxiosParamCreator(configuration).apiRedeemerErrorGetGet(server, page, itemsPerPage, sortBy, sortDesc, searchTerm, showResolved, showUnresoved, languageCode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {ResolutionPost} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerErrorResolvePost(body?: ResolutionPost, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await RedeemerErrorApiAxiosParamCreator(configuration).apiRedeemerErrorResolvePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RedeemerErrorApi - factory interface
 * @export
 */
export const RedeemerErrorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [searchTerm] 
         * @param {boolean} [showResolved] 
         * @param {boolean} [showUnresoved] 
         * @param {string} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerErrorArchivedGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, showResolved?: boolean, showUnresoved?: boolean, languageCode?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<RedeemerErrorArchivePagedResponse>> {
            return RedeemerErrorApiFp(configuration).apiRedeemerErrorArchivedGet(server, page, itemsPerPage, sortBy, sortDesc, searchTerm, showResolved, showUnresoved, languageCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerErrorDeleteDelete(server?: string, id?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return RedeemerErrorApiFp(configuration).apiRedeemerErrorDeleteDelete(server, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [searchTerm] 
         * @param {boolean} [showResolved] 
         * @param {boolean} [showUnresoved] 
         * @param {string} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerErrorGetGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, showResolved?: boolean, showUnresoved?: boolean, languageCode?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<RedeemerErrorPagedResponse>> {
            return RedeemerErrorApiFp(configuration).apiRedeemerErrorGetGet(server, page, itemsPerPage, sortBy, sortDesc, searchTerm, showResolved, showUnresoved, languageCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResolutionPost} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerErrorResolvePost(body?: ResolutionPost, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return RedeemerErrorApiFp(configuration).apiRedeemerErrorResolvePost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RedeemerErrorApi - object-oriented interface
 * @export
 * @class RedeemerErrorApi
 * @extends {BaseAPI}
 */
export class RedeemerErrorApi extends BaseAPI {
    /**
     * 
     * @param {string} [server] 
     * @param {number} [page] 
     * @param {number} [itemsPerPage] 
     * @param {string} [sortBy] 
     * @param {boolean} [sortDesc] 
     * @param {string} [searchTerm] 
     * @param {boolean} [showResolved] 
     * @param {boolean} [showUnresoved] 
     * @param {string} [languageCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemerErrorApi
     */
    public async apiRedeemerErrorArchivedGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, showResolved?: boolean, showUnresoved?: boolean, languageCode?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<RedeemerErrorArchivePagedResponse>> {
        return RedeemerErrorApiFp(this.configuration).apiRedeemerErrorArchivedGet(server, page, itemsPerPage, sortBy, sortDesc, searchTerm, showResolved, showUnresoved, languageCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemerErrorApi
     */
    public async apiRedeemerErrorDeleteDelete(server?: string, id?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return RedeemerErrorApiFp(this.configuration).apiRedeemerErrorDeleteDelete(server, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {number} [page] 
     * @param {number} [itemsPerPage] 
     * @param {string} [sortBy] 
     * @param {boolean} [sortDesc] 
     * @param {string} [searchTerm] 
     * @param {boolean} [showResolved] 
     * @param {boolean} [showUnresoved] 
     * @param {string} [languageCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemerErrorApi
     */
    public async apiRedeemerErrorGetGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, showResolved?: boolean, showUnresoved?: boolean, languageCode?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<RedeemerErrorPagedResponse>> {
        return RedeemerErrorApiFp(this.configuration).apiRedeemerErrorGetGet(server, page, itemsPerPage, sortBy, sortDesc, searchTerm, showResolved, showUnresoved, languageCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {ResolutionPost} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemerErrorApi
     */
    public async apiRedeemerErrorResolvePost(body?: ResolutionPost, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return RedeemerErrorApiFp(this.configuration).apiRedeemerErrorResolvePost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
